module.exports = __webpack_public_path__ + "static/img/jianjie.5928263.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie.png
// module id = Aulw
// module chunks = 1